import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeart = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 24,
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m12.37 1.977a6.844 6.844 0 0 1 4.816-1.977c1.807 0 3.54.711 4.817 1.977a6.714 6.714 0 0 1 1.997 4.773c0 1.79-.718 3.506-1.996 4.771l-9.263 9.176a1.055 1.055 0 0 1 -1.482 0l-9.264-9.177a6.703 6.703 0 0 1 0-9.543c2.66-2.635 6.974-2.635 9.635 0l.37.366zm-.37 16.517 7.411-7.341 1.111-1.1a4.649 4.649 0 0 0 1.382-3.304c0-1.24-.497-2.428-1.382-3.304a4.739 4.739 0 0 0 -3.335-1.37c-1.251 0-2.451.493-3.336 1.37l-1.11 1.1a1.055 1.055 0 0 1 -1.482 0l-1.111-1.1a4.749 4.749 0 0 0 -6.67 0 4.641 4.641 0 0 0 0 6.607z",
		fill: "#2b2b2b",
		transform: "translate(0 2)"
	})
});
export default SvgHeart;
